module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-83dd5fa30f4e62159197910665635691.png";